import { render, staticRenderFns } from "./crud.vue?vue&type=template&id=03d6436c&scoped=true&"
import script from "./crud.vue?vue&type=script&lang=js&"
export * from "./crud.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d6436c",
  null
  
)

export default component.exports